<div class="v2-modal" [attr.data-size]="size">
  <header class="v2-modal__header">
    <div class="v2-modal__titles">
      <div class="v2-modal__title">{{ title }}</div>
      @if (subtitle) { <div class="v2-modal__subtitle">{{ subtitle }}</div> }
    </div>
    @if (!hideClose) {
      <button type="button" class="v2-modal__close" (click)="closeClick.emit()" title="Zapri" i18n-title>
        <i class="fas fa-times"></i>
      </button>
    }
  </header>

  <div class="v2-modal__body">
    <ng-content select="[slot=body]" />
    <ng-content />
  </div>

  <footer class="v2-modal__footer">
    <ng-content select="[slot=footer]" />
  </footer>
</div>
